export const GETALLNOTIFICATIONS = 'GETALLNOTIFICATIONS';
export const GETALLNOTIFICATIONSETTING = 'GETALLNOTIFICATIONSETTING';
export const GETALLUSERS = 'GETALLUSERS';
export const GETALLUSERGROUPS = 'GETALLUSERGROUPS';
export const GETALLBUTTONOPTIONS = 'GETALLBUTTONOPTIONS';
export const GETALLCOURSES = 'GETALLCOURSES';
